import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Polyline, TileLayer, useMap } from "react-leaflet";

const TEMPLIN = [53.1189, 13.5022];

const pinIcon = (label, bg, fg = "#120E09") =>
    L.divIcon({
        className: "",
        html:
            `<div style="display:flex;flex-direction:column;align-items:center;transform:translate(-50%,-100%)">` +
            `<span style="background:${bg};color:${fg};font:700 11px Manrope,sans-serif;padding:4px 10px;border-radius:999px;white-space:nowrap;box-shadow:0 2px 10px rgba(0,0,0,.55);border:1px solid rgba(0,0,0,.35)">${label}</span>` +
            `<span style="width:2px;height:10px;background:${bg}"></span>` +
            `<span style="width:8px;height:8px;border-radius:50%;background:${bg};box-shadow:0 0 0 3px rgba(0,0,0,.35)"></span>` +
            `</div>`,
        iconSize: [0, 0],
    });

const FitAndReady = ({ points }) => {
    const map = useMap();
    useEffect(() => {
        map.fitBounds(L.latLngBounds(points), { padding: [40, 40] });
        const t = setTimeout(() => map.invalidateSize(), 250);
        return () => clearTimeout(t);
    }, [map, points]);
    return null;
};

export const RouteMap = ({ dest, route }) => {
    const destPoint = [dest.lat, dest.lon];
    const line = route && route.length > 1 ? route : [TEMPLIN, destPoint];
    return (
        <MapContainer
            center={TEMPLIN}
            zoom={9}
            scrollWheelZoom={false}
            attributionControl={true}
            style={{ height: "280px", width: "100%", background: "#120E09" }}
            data-testid="route-map"
        >
            <TileLayer
                className="map-tiles-dark"
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende'
            />
            <Marker position={TEMPLIN} icon={pinIcon("Templin — KischioWood", "#C88A45")} />
            <Marker position={destPoint} icon={pinIcon(dest.label, "#7A9B5A")} />
            <Polyline
                positions={line}
                pathOptions={
                    route && route.length > 1
                        ? { color: "#C88A45", weight: 4, opacity: 0.9 }
                        : { color: "#C88A45", weight: 3, opacity: 0.8, dashArray: "8 8" }
                }
            />
            <FitAndReady points={[TEMPLIN, destPoint]} />
        </MapContainer>
    );
};
